export const GROUP_CATEGORY = {
    COURSE: 'COURSE',
    CLOSED_COMMUNITY: 'CLOSED_COMMUNITY',
    OPEN_COMMUNITY: 'OPEN_COMMUNITY',
};